import { c as _c } from "react/compiler-runtime";
import { gql, useMutation, useQuery } from "@apollo/client";

// Common GraphQL queries and mutations for the sell flow

export const GET_UNIT_ID_QUERY = gql`
	query GetUnitId($params: RawUnitQueryParams) {
		rawUnits(params: $params) {
			one {
				unitId
				block
				name
			}
		}
	}
`;
export const CREATE_OR_UPDATE_RAW_UNIT = gql`
	mutation Mutation($params: RawUnitInputParam) {
		rawUnit(params: $params) {
			createOrUpdateRawUnit {
				id
				groupId
				message
			}
		}
	}
`;
export const CREATE_UNIT_AND_CONFIRM_MUTATION = gql`
	mutation UnitMethods($filters: UnitMethodFilters) {
		unitMethods(filters: $filters) {
			createUnitAndConfirmFee {
				sellerUnitId
			}
		}
	}
`;
export const GET_SELLER_GROUP_DATA_QUERY = gql`
	query Query($params: SellerQueryParams) {
		seller(params: $params) {
			getSellerGroup {
				id
				identifier
				name
				type
				relationship
				entityType
				companyName
				gstNo
				officeAddress
				relationship
				projects {
					id
					name
					noOfFlatsForSale
					propertyTypes
					totalFlats
				}
			}
		}
	}
`;

// Custom hook for getting unit ID
export function useGetUnitId(params) {
  const $ = _c(6);
  let t0;
  if ($[0] !== params.groupId || $[1] !== params.id) {
    t0 = {
      params: {
        list: {
          groupId: params.groupId,
          id: params.id
        }
      }
    };
    $[0] = params.groupId;
    $[1] = params.id;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = !(params.groupId && params.id) || !!params.sellerUnitId || !!params.unitId;
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = {
      variables: t0,
      skip: t1,
      fetchPolicy: "cache-and-network"
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return useQuery(GET_UNIT_ID_QUERY, t2);
}
export function useGetSellerGroupData(t0) {
  const $ = _c(6);
  const {
    groupId,
    userId,
    isAuthenticated
  } = t0;
  let t1;
  if ($[0] !== groupId || $[1] !== userId) {
    t1 = {
      params: {
        getSellerGroup: {
          groupId,
          userId
        }
      }
    };
    $[0] = groupId;
    $[1] = userId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = !isAuthenticated || Boolean(!groupId);
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      variables: t1,
      skip: t2
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return useQuery(GET_SELLER_GROUP_DATA_QUERY, t3);
}
export const GET_BLOCK_DATA_QUERY = gql`
	query Blocks($params: BlockParams) {
		blocks(params: $params) {
			list {
				id
				name
				constructedOn
				launchedOn
			}
		}
	}
`;
export function useGetBlockData(params) {
  const $ = _c(5);
  let t0;
  if ($[0] !== params.sellerUnitId) {
    t0 = {
      params: {
        list: {
          sellerUnitId: params.sellerUnitId
        }
      }
    };
    $[0] = params.sellerUnitId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !params.sellerUnitId;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      variables: t0,
      skip: t1,
      fetchPolicy: "cache-and-network"
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(GET_BLOCK_DATA_QUERY, t2);
}
// Custom hook for creating/updating raw unit
export function useCreateOrUpdateRawUnit() {
  return useMutation(CREATE_OR_UPDATE_RAW_UNIT);
}

// Custom hook for creating unit and confirming fee
export function useCreateUnitAndConfirmFee() {
  return useMutation(CREATE_UNIT_AND_CONFIRM_MUTATION);
}